var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup704(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 102,
    viewBox: "0 0 118 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 54.7906,
    width: 4.52941,
    height: 4.52941,
    fill: "#BAE3F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.059,
    y: 39.5604,
    width: 4.52941,
    height: 4.52941,
    transform: "rotate(-180 117.059 39.5604)",
    fill: "#BAE3F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M68.6285 64.4717H51.447V81.6438H68.6285V64.4717Z",
    fill: "#BAE3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M44.3375 15.3232H27.156V32.4954H44.3375V15.3232Z",
    fill: "#BAE3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M68.6285 15.3232H51.447V32.4954H68.6285V15.3232Z",
    fill: "#BAE3F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M92.6232 15.3232H75.4418V32.4954H92.6232V15.3232Z",
    fill: "#BAE3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M44.3375 39.8975H27.156V57.0696H44.3375V39.8975Z",
    fill: "#BAE3F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M68.6285 39.6013H51.447V56.7735H68.6285V39.6013Z",
    fill: "#BAE3F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M92.6232 39.6013H75.4418V56.7735H92.6232V39.6013Z",
    fill: "#BAE3F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M44.3375 64.4717H27.156V81.6438H44.3375V64.4717Z",
    fill: "#BAE3F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M92.6232 64.4717H75.4418V81.6438H92.6232V64.4717Z",
    fill: "#BAE3F9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3752 11.4742H24.1937V28.6464H41.3752V11.4742Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6662 11.4742H48.4848V28.6464H65.6662V11.4742Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6609 11.4742H72.4795V28.6464H89.6609V11.4742Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3752 36.0482H24.1937V53.2204H41.3752V36.0482Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6662 36.0482H48.4848V53.2204H65.6662V36.0482Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6609 36.0482H72.4795V53.2204H89.6609V36.0482Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3752 60.3259H24.1937V77.4981H41.3752V60.3259Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6662 60.3259H48.4848V77.4981H65.6662V60.3259Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6609 60.3259H72.4795V77.4981H89.6609V60.3259Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4384 89.045H22.7126C17.6767 89.045 13.5294 84.9 13.5294 79.8668V11.1782C13.5294 6.145 17.6767 2 22.7126 2H91.4384C96.4744 2 100.622 6.145 100.622 11.1782V79.8668C100.622 84.9 96.4744 89.045 91.4384 89.045Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0756 89.0449V99.9996",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3752 100H72.4796",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup704);
export default __webpack_public_path__ + "static/media/Group-704.561cc0a6c75e186bbd7a74c30b6a26a1.svg";
export { ForwardRef as ReactComponent };